export default "__VITE_ASSET__DChIobep__"